import { combineReducers } from "redux";
import { authReducer } from "./auth.reducer";
import { locationReducer } from "./location.reducer";
import { markerReducer } from "./marker.reducer";

export default combineReducers({
  auth: authReducer,
  location: locationReducer,
  marker: markerReducer,
});
